var React = require('react');

function IconEmailInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0,0V36H50V0ZM2,2H48V4.506c-.424.37-18.186,15.85-19.664,17.137A5.189,5.189,0,0,1,25,23a5.189,5.189,0,0,1-3.336-1.359C20.186,20.356,2.424,4.876,2,4.506ZM2,7.15c2.438,2.126,16.968,14.792,18.354,16A7.17,7.17,0,0,0,25,25a7.17,7.17,0,0,0,4.646-1.85C31.032,21.942,45.562,9.277,48,7.152V34H2Z"}));
}

IconEmailInline.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 50 36"};

module.exports = IconEmailInline;

IconEmailInline.default = IconEmailInline;
